import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AppShell } from "../components/Nav";

export default function Bracket() {
  const [loading, setLoading] = useState(true);
  const [shortlist, setShortlist] = useState([]);

  useEffect(() => {
    const token = localStorage.getItem("token");

    fetch("/api/journey/shortlist", {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(res => res.ok ? res.json() : [])
      .then(data => {
        setShortlist(data || []);
        setLoading(false);
      })
      .catch(() => {
        setShortlist([]);
        setLoading(false);
      });
  }, []);

  return (
    <AppShell>
      <div className="px-6 md:px-12 py-10 md:py-14">

        <h1 className="font-display text-4xl md:text-6xl mb-6">
          Your journey
        </h1>

        {loading && (
          <div className="text-white/60">Loading your journey…</div>
        )}

        {!loading && shortlist.length === 0 && (
          <div className="glass rounded-2xl p-8 text-center">
            <h2 className="text-xl mb-3">Start your journey</h2>
            <p className="text-white/60 mb-6">
              You haven’t selected your seven yet.
            </p>
            <Link
              to="/select-seven"
              className="rounded-full bg-gradient-gold px-6 py-3 text-black font-semibold"
            >
              Choose your seven →
            </Link>
          </div>
        )}

        {!loading && shortlist.length > 0 && (
          <div className="glass rounded-2xl p-8 text-center">
            <h2 className="text-xl mb-3">Your bracket is building</h2>
            <p className="text-white/60 mb-6">
              Continue your rounds to see your matches evolve.
            </p>
            <Link
              to="/round"
              className="rounded-full border border-white/20 px-6 py-3"
            >
              Continue →
            </Link>
          </div>
        )}

      </div>
    </AppShell>
  );
}
